var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Schema, LayoutWidget, LayoutWidgetHeader, LayoutWidgetBody, LayoutWidgetEdit } from "../";

var EditableWidget = (_temp2 = _class = function (_Component) {
    _inherits(EditableWidget, _Component);

    function EditableWidget() {
        var _temp, _this, _ret;

        _classCallCheck(this, EditableWidget);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            editing: false
        }, _this.onAdd = function (props) {
            console.log('editableWidget:add', props);

            if (_this.props.onAdd) {
                _this.props.onAdd(props);
            }
        }, _this.onRemove = function (props) {
            console.log('editableWidget:remove', props);

            if (_this.props.onRemove) {
                _this.props.onRemove(props);
            }
        }, _this.onEdit = function (props) {
            console.log('editableWidget:edit', props);

            _this.setState({
                editing: true
            });
        }, _this.onSave = function (props) {
            console.log('editableWidget:save', props);

            _this.setState({
                editing: false
            });

            if (_this.props.onSave) {
                _this.props.onSave(props);
            }
        }, _this.getUiSchema = function () {
            var _this$props = _this.props,
                uiSchema = _this$props.uiSchema,
                expanded = _this$props.expanded,
                editable = _this$props.editable,
                removable = _this$props.removable,
                addable = _this$props.addable,
                style = _this$props.style;


            return _extends({}, uiSchema, {
                "ui:style": style,
                "ui:options": {
                    "expanded": expanded,
                    "editable": editable,
                    "addable": addable,
                    "removable": removable
                }
            });
        }, _this.getFormData = function () {
            var _this$props2 = _this.props,
                formData = _this$props2.formData,
                widgetType = _this$props2.widgetType,
                widgetSize = _this$props2.widgetSize,
                title = _this$props2.title,
                description = _this$props2.description,
                icon = _this$props2.icon,
                imageUrl = _this$props2.imageUrl;


            var image = void 0;

            if (imageUrl) {

                image = {
                    mediaId: true,
                    media: {
                        imageUrl: imageUrl
                    }
                };
            }

            return _extends({
                widgetType: widgetType,
                widgetSize: widgetSize,
                title: title,
                description: description,
                icon: icon,
                image: image
            }, formData);
        }, _this.getLayouts = function () {
            var editing = _this.state.editing;
            var _this$props3 = _this.props,
                widgetTemplate = _this$props3.widgetTemplate,
                widgetEditor = _this$props3.widgetEditor;


            var layouts = {
                "widget": LayoutWidget,
                "widget-header": LayoutWidgetHeader,
                "widget-body": function widgetBody() {
                    return _this.props.children;
                }
            };

            if (editing && widgetEditor) {
                layouts['widget-header'] = function () {
                    return false;
                };
                layouts['widget-body'] = widgetEditor;
            } else if (editing) {
                layouts['widget-body'] = LayoutWidgetEdit;
            } else if (widgetTemplate) {
                layouts['widget-header'] = function () {
                    return false;
                };
                layouts['widget-body'] = widgetTemplate;
            }

            return layouts;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    EditableWidget.prototype.render = function render() {
        var formData = this.getFormData();
        var uiSchema = this.getUiSchema();
        var layouts = this.getLayouts();

        return React.createElement(Schema, _extends({}, this.props, { formData: formData, uiSchema: uiSchema, layouts: layouts,
            onAdd: this.onAdd, onRemove: this.onRemove, onEdit: this.onEdit, onSave: this.onSave }));
    };

    return EditableWidget;
}(Component), _class.defaultProps = {
    addable: false,
    removable: false,
    expanded: false,
    editable: false,
    formData: {},
    schema: {
        type: "object",
        properties: {
            widgetType: {
                type: "string"
            },
            widgetSize: {
                type: "string",
                pattern: "grid",
                enum: ["1:1", "2:1", "3:1", "4:1", "1:2", "2:2", "3:2", "4:2", "1:3", "2:3", "3:3", "4:3", "1:4", "2:4", "3:4", "4:4"]
            },
            title: {
                type: "string"
            },
            description: {
                type: "string",
                format: "email"
            },
            icon: {
                type: "string"
            },
            image: {
                type: "image"
            }
        }
    },
    uiSchema: {
        "ui:layout": "widget",
        "ui:title": {
            "select": "title"
        },
        "ui:description": {
            "select": "description"
        },
        "ui:fieldset": ["header", "body"],
        "header": {
            "ui:layout": "widget-header",
            "ui:fieldset": ["title", "description"],
            "ui:title": {
                "select": "title"
            }
        },
        "body": {
            "ui:layout": "widget-body",
            "ui:fieldset": ["title", "description"]
        },
        "ui:settings": ["widgetSize"]
    }
}, _temp2);


export default EditableWidget;